import {AlertIcon} from '@primer/octicons-react'
import {announce} from '@github-ui/aria-live'
import {Blankslate} from '@primer/react/experimental'
import {useEffect, type MouseEvent} from 'react'

export const RUNNERS_FOCUS_TARGET_ATTRIBUTE = 'data-runners-focus-target'

export function RunnersError({onRetry}: {onRetry: () => void}) {
  useEffect(() => {
    announce('Unable to load runners. An error occurred while loading runners. Please try again.')
  }, [])

  return (
    <Blankslate border>
      <Blankslate.Visual>
        <AlertIcon size={24} />
      </Blankslate.Visual>
      <Blankslate.Heading>Unable to load runners</Blankslate.Heading>
      <Blankslate.Description>An error occurred while loading runners. Please try again.</Blankslate.Description>
      <Blankslate.PrimaryAction
        onClick={(event: MouseEvent<HTMLElement>) => {
          // Retrying unmounts this button, so keep focus on a container that stays mounted.
          event.currentTarget.closest<HTMLElement>(`[${RUNNERS_FOCUS_TARGET_ATTRIBUTE}]`)?.focus()
          onRetry()
        }}
      >
        Try again
      </Blankslate.PrimaryAction>
    </Blankslate>
  )
}
